import {merge} from 'lodash';
import {useCallback, useContext, useMemo} from 'react';

import {CameraSwitcher, DropdownProps} from 'components';
import {UserSessionContext} from 'context';
import {FacingMode} from 'enums';
import {useMediaDevices} from 'hooks';

type Props = {
    dropdownProps?: Partial<DropdownProps>;
}

export const UserCameraSwitcher: React.FC<Props> = ({dropdownProps}: Props) => {
    const {videoDevices} = useContext(UserSessionContext);
    const [mediaDevices, setMediaDevices] = useMediaDevices();

    const videoConstraints = useMemo(() => ({
        ...(mediaDevices?.videoinput && {deviceId: {exact: mediaDevices?.videoinput}}),
        ...(mediaDevices?.facingMode && {facingMode: {exact: mediaDevices?.facingMode || FacingMode.User}})
    }), [mediaDevices?.facingMode, mediaDevices?.videoinput]);

    const handleUpdateVideoDevice = useCallback((params: MediaTrackConstraintSet) => {
        if (params?.deviceId) {
            setMediaDevices(merge({}, mediaDevices, {videoinput: (params?.deviceId as ConstrainDOMStringParameters).exact}));
        }
        if (params?.facingMode) {
            setMediaDevices(merge({}, mediaDevices, {facingMode: (params?.facingMode as ConstrainDOMStringParameters).exact}));
        }
    }, [mediaDevices, setMediaDevices]);

    return (
        <CameraSwitcher
            dropdownProps={dropdownProps}
            videoDevices={videoDevices}
            constraints={videoConstraints}
            updateVideoDevice={handleUpdateVideoDevice}
        />
    );
};
